type CustomerIdType = string | number | null | undefined

const normalize = (id: CustomerIdType): string => `${id ?? ''}`.trim()

export const isCustomerNumberValid = (userId: CustomerIdType, anonymousUserId?: string): boolean => {
  if (!userId) return false

  const normalizedValue = normalize(userId)
  let valid = normalizedValue.length > 0
  if (valid && anonymousUserId) {
    valid = valid && normalizedValue !== anonymousUserId
  }
  return valid
}
